import React, { useEffect, useState } from 'react'
import Text from '../../../../../components/Atomsv2/Text/Text'
import CardDashboard from '../../../../../components/moleculesv2/DashboardCard/CardDashboard'
import Table from '../../../../../components/moleculesv2/Table/Table'
import './CrudServicios.scss'
import Card from '../../../../../components/Atomsv2/Card/Card'
import Column from '../../../../../components/moleculesv2/Table/Column'
import Button from '../../../../../components/Atomsv2/Button/Button'
import Tooltip from '../../../../../components/Atomsv2/Tooltip/Tooltip'
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel'
import Input from '../../../../../components/Atomsv2/Input/Input'
import Textarea from '../../../../../components/Atomsv2/Textarea/Textarea'
import { crearConcepto, crearServicio, updateConcepto, updateServicio } from '../../integracionPaquetes'
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast'
import Select from '../../../../../components/Atomsv2/Select/Select'
const CrudServicios = ({ data, setData }) => {
    const { toasts, addToast, removeToast } = useToast();
    const [sidePanelData, setSidePanelData] = useState(false)
    const [openCrear, setOpenCrear] = useState(false)
    const [form, setForm] = useState({
        id: null,
        servicio: null,
        tipoServicio: null,
        tipoUnidad: null,
        km: null,
        tiempoHoras: null

    })
    const [nombreServicio, setNombreServicio] = useState({
        tipo: null,
        km: null,
        tipoUnidad: null,
    })
    const [cards, setCards] = useState([
        {
            title: "1",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        },
        {
            title: "2",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        },
        {
            title: "3",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        }
    ])
    useEffect(() => {
        if (nombreServicio && openCrear == true) {
            console.log("entro")
            setForm(prev => ({
                ...prev, servicio: `${nombreServicio.tipo ? `SERVICIO DE TIPO ${nombreServicio.tipo}` : ""} ${nombreServicio.km ? `DE ${nombreServicio.km} KILÓMETROS,` : ""} ${nombreServicio.tipoUnidad ? ` PARA ${nombreServicio.tipoUnidad}` : ""}`
            }))
        }
    }, [nombreServicio])

    const editarContenido = (rowData) => {
        setForm({
            id: rowData.ID,
            servicio: rowData.SERVICIO,
            tipoServicio: rowData.TIPO_SERVICIO,
            tipoUnidad: { name: rowData.TIPO_UNIDAD, code: rowData.ID_TIPO_UNIDAD },
            km: rowData.KM,
            tiempoHoras: rowData.TIEMPO_HORAS
        })
        setSidePanelData(rowData)
    }
    const editar = async () => {
        if (form.tipoUnidad && form.km && form.servicio && form.tiempoHoras && form.tipoServicio) {
            setData(prev => ({
                ...prev,
                servicios: prev.servicios.map((item) => {
                    return item.ID == form.id ?
                        {
                            ...item,
                            ID_TIPO_UNIDAD: form.tipoUnidad.value ?? form.tipoUnidad.code,
                            KM: form.km,
                            TIEMPO_HORAS: form.tiempoHoras,
                            TIPO_SERVICIO: form.tipoServicio,
                            TIPO_UNIDAD: form.tipoUnidad?.name,
                            SERVICIO: form.servicio
                        }
                        :
                        item
                })
            }))
            const sendData = {
                id: form.id,
                servicio: form.servicio,
                tipoServicio: form.tipoServicio,
                tipoUnidad: form.tipoUnidad.value ?? form.tipoUnidad.code,
                km: form.km,
                tiempoHoras: form.tiempoHoras,
            }
            await updateServicio(sendData)
            limpiar(setSidePanelData)
        }
        else {
            addToast("Completa todos los campos", "error", 5000, "light");
        }
    }
    console.log("form",form);
    
    const crear = async () => {
        if (form.tipoUnidad && form.km && form.servicio && form.tiempoHoras && form.tipoServicio) {
            let id = null
            const sendData = {
                servicio: form.servicio,
                tipoServicio: form.tipoServicio,
                tipoUnidad: form.tipoUnidad.value ?? form.tipoUnidad.code,
                km: form.km,
                tiempoHoras: form.tiempoHoras,
            }
            await crearServicio(sendData)
                .then((res) => {
                    id = res.ID
                })
                .catch((error) => {
                    addToast("error al crear servicio", "error", 5000, "light");

                })
           
            setData(prev => ({
                ...prev,
                servicios: [
                    ...prev.servicios,
                    {
                        ID:id,
                        ID_TIPO_UNIDAD: form.tipoUnidad.value ?? form.tipoUnidad.code,
                        KM: form.km,
                        TIEMPO_HORAS: form.tiempoHoras,
                        TIPO_SERVICIO: form.tipoServicio,
                        TIPO_UNIDAD: form.tipoUnidad?.name,
                        SERVICIO: form.servicio
                    }
                ]

            }))
            limpiar(setOpenCrear)
        }
        else {
            addToast("Completa todos los campos", "error", 5000, "light");
        }
    }
    const limpiar = (cerrar) => {
        setForm({
            id: null,
            servicio: null,
            tipoServicio: null,
            tipoUnidad: null,
            km: null,
            tiempoHoras: null
        })
        if(cerrar){cerrar(false)}
        
    }

    return (
        <div className='CrudServicios'>
            <Card>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button style={{ marginBottom: "10px" }} icon='add' onClick={() => {limpiar(); setOpenCrear(true) }}>Nuevo</Button>
                </div>
                <div className="cardsContainer" style={{ marginBottom: "10px" }}>
                    {
                        cards.map((card) => {
                            return (
                                <CardDashboard
                                    title={card.title}
                                    icon={card.icon}
                                    iconColor={card.iconColor}
                                    footer={card.footer}
                                >
                                    {card.contenido}
                                </CardDashboard>
                            )
                        })
                    }

                </div>
                <Table globalFilter data={data?.servicios} height="calc(100vh - 385px)">
                    <Column sortable header={"ID"} value={"ID"}></Column>
                    <Column sortable header={"SERVICIO"} value={"SERVICIO"}></Column>
                    <Column sortable header={"TIPO DE UNIDAD"} value={"TIPO_UNIDAD"}></Column>
                    <Column sortable header={"TIPO DE SERVICIO"} value={"TIPO_SERVICIO"}></Column>
                    <Column sortable header={"KM"} value={"KM"}></Column>
                    <Column sortable header={"TIEMPO_HORAS"} value={"TIEMPO_HORAS"}></Column>
                    <Column header={"EDITAR"} body={(rowData) => { return (<Tooltip content={"Editar contenido"}><Button onClick={() => { editarContenido(rowData) }} icon="edit"></Button></Tooltip>) }}></Column>
                </Table>
            </Card>
            <SidePanel tabToClose={false} title={"Editar Servicio"} subtitle={"Realiza modificaciones de los servicios."} icon={"edit"} open={sidePanelData} onClose={() => { limpiar(setSidePanelData) }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}><Button onClick={() => { editar() }} icon={"save"}>Guardar</Button></div>
                <Input label='Tipo de servicio' placeholder={"Ingresa un tipo A,B,C... "} value={form.tipoServicio} onChange={(e) => { setForm(prev => ({ ...prev, tipoServicio: e.target.value })); setNombreServicio(prev => ({ ...prev, tipo: e.target.value })) }}></Input>
                <Input type='number' label='Kilometraje' placeholder={"Ingresa cada cuantos kilómetros se realizara el servicio "} value={form.km} onChange={(e) => { setForm(prev => ({ ...prev, km: e.target.value })); setNombreServicio(prev => ({ ...prev, km: e.target.value })) }}></Input>
                <Select mapper={{ name: "name", value: "code" }} options={data.tipoUnidades} value={form.tipoUnidad} onChange={(e) => { setForm(prev => ({ ...prev, tipoUnidad: e })); setNombreServicio(prev => ({ ...prev, tipoUnidad: e.name })) }}></Select>
                <Input type='number' label='Tiempo en horas' placeholder={"Ingresa cuantas horas tardara el servicio "} value={form.tiempoHoras} onChange={(e) => { setForm(prev => ({ ...prev, tiempoHoras: e.target.value })) }}></Input>
                <Input
                    label='Nombre'
                    placeholder={"Ingresa el nombre del servicio "}
                    value={form.servicio}
                    onChange={(e) => {

                        setForm(prev => ({
                            ...prev,
                            servicio: e.target.value
                        }))
                    }
                    }
                ></Input>

            </SidePanel>

            <SidePanel tabToClose={false} title={"Crear Servicio"} subtitle={"Crear servicios."} icon={"add"} open={openCrear} onClose={() => { limpiar(setOpenCrear) }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}><Button onClick={() => { crear() }} icon={"save"}>Guardar</Button></div>
                <Input label='Tipo de servicio' placeholder={"Ingresa un tipo A,B,C... "} value={form.tipoServicio} onChange={(e) => { setForm(prev => ({ ...prev, tipoServicio: e.target.value })); setNombreServicio(prev => ({ ...prev, tipo: e.target.value })) }}></Input>
                <Input type='number' label='Kilometraje' placeholder={"Ingresa cada cuantos kilómetros se realizara el servicio "} value={form.km} onChange={(e) => { setForm(prev => ({ ...prev, km: e.target.value })); setNombreServicio(prev => ({ ...prev, km: e.target.value })) }}></Input>
                <Select mapper={{ name: "name", value: "code" }} options={data.tipoUnidades} value={form.tipoUnidad} onChange={(e) => { setForm(prev => ({ ...prev, tipoUnidad: e })); setNombreServicio(prev => ({ ...prev, tipoUnidad: e.name })) }}></Select>
                <Input type='number' label='Tiempo en horas' placeholder={"Ingresa cuantas horas tardara el servicio "} value={form.tiempoHoras} onChange={(e) => { setForm(prev => ({ ...prev, tiempoHoras: e.target.value })) }}></Input>
                <Input
                    label='Nombre'
                    placeholder={"Ingresa el nombre del servicio "}
                    value={form.servicio}
                    onChange={(e) => {

                        setForm(prev => ({
                            ...prev,
                            servicio: e.target.value
                        }))
                    }
                    }
                ></Input>
                

            </SidePanel>
            <ToastContainer toasts={toasts} removeToast={removeToast} />

        </div>
    )
}
export default CrudServicios